import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { getFullNameUser } from "@/js/user/user.js";
import { formatPrice, roundToTwoDigit, getSymbolCurrency } from "@/js/currency/currencies.js";
import { inboundDeliveryStatus, paymentState, paymentStates, paymentTypes, paymentTypesWithCN } from "@/js/lists.ts";
export default {
  name: "InboundDeliveryPaymentDetailsDialog",
  props: {
    loggedUserData: Object,
    dialog: Boolean,
    payment: Object,
    inboundDelivery: Object
  },
  data: function data() {
    return {
      options: {
        color: "primary",
        width: 600,
        zIndex: 2000
      },
      isAdding: false,
      isValidating: false,
      savePaymentToken: null,
      model: {
        id: null,
        state: null,
        paymentDate: new Date().formatForDatePickerDays(),
        type: null,
        typeLabel: null,
        methodId: null,
        microDepositsUrl: null,
        amount: 0.01,
        scheduleDate: null,
        userId: null,
        inboundDeliveryId: null
      },
      scheduleDateOpened: false,
      paymentDateMenu: false,
      isEditingPayment: false,
      listPaymentMethods: [],
      modelPaymentMethod: null,
      isSavingPayment: false,
      rules: formRules,
      paymentState: paymentState,
      paymentStates: paymentStates,
      paymentTypes: paymentTypes,
      paymentTypesWithCN: paymentTypesWithCN
    };
  },
  computed: {
    isPaymentEditable: function isPaymentEditable() {
      var _this$payment, _this$payment2;
      return !this.isEditingPayment && (!((_this$payment = this.payment) !== null && _this$payment !== void 0 && _this$payment.state) || ((_this$payment2 = this.payment) === null || _this$payment2 === void 0 ? void 0 : _this$payment2.state) !== paymentState.SUCCEEDED) && this.inboundDelivery.status !== inboundDeliveryStatus.find(function (x) {
        return x.id === "CANCELLED";
      }).status;
    },
    remainingAmount: function remainingAmount() {
      var _this2 = this;
      var amountPayment = 0;
      this.inboundDelivery.payments.forEach(function (x) {
        if (x.id != _this2.model.id) {
          amountPayment += x.amount;
        }
      });
      return roundToTwoDigit(this.inboundDelivery.totalAmountCurrencyIncludeShipping - amountPayment);
    },
    isDisabled: function isDisabled() {
      return !this.model.amount || this.model.state === paymentState.SUCCEEDED && !this.model.paymentDate || !this.model.state;
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this3.payment) {
              _this3.model = _objectSpread(_objectSpread({}, _this3.payment), {}, {
                paymentDate: _this3.payment.paymentDate ? new Date(_this3.payment.paymentDate).formatForDatePickerDays() : new Date().formatForDatePickerDays(),
                scheduleDate: _this3.payment.scheduleDate ? new Date(_this3.payment.scheduleDate).formatForDatePickerDays() : null
              });
            } else {
              _this3.isAdding = true;
              _this3.model.inboundDeliveryId = _this3.inboundDelivery.id;
              _this3.model.amount = _this3.remainingAmount;
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    close: function close() {
      this.$emit("close");
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this4$savePaymentTok;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this4;
              (_this4$savePaymentTok = _this4.savePaymentToken) === null || _this4$savePaymentTok === void 0 || _this4$savePaymentTok.cancel();
              _this4.savePaymentToken = axios.CancelToken.source();
              if (!_this4.isAdding) {
                _context2.next = 10;
                break;
              }
              _context2.next = 6;
              return request("/v1/payment", "post", _this4.model, true, "api", null, _this4.savePaymentToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to add the payment.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 6:
              response = _context2.sent;
              if (response) {
                _this4.model.id = response.data.value;
              }
              _context2.next = 12;
              break;
            case 10:
              _context2.next = 12;
              return request("/v1/payment/".concat(_this4.model.id), "put", _this4.model, true, "api", null, _this4.savePaymentToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to change the payment.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 12:
              _this4.$emit("validate", true, function () {
                _this4.close();
                _this4.$toasted.show("Payment succesfully saved.", {
                  type: "success"
                });
              });
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    changeAmountCurrency: function changeAmountCurrency() {
      if (this.remainingAmount < this.model.amount) {
        this.model.amount = this.remainingAmount;
      } else if (this.model.amount <= 0) {
        this.model.amount = 0.01;
      }
    },
    startEditPaymentMethod: function startEditPaymentMethod() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.listPaymentMethods = [];
              _context3.next = 3;
              return request("/v1/stripe/purchase/payment-methods?inboundDeliveryId=".concat(_this5.inboundDelivery.id), "get", null, true, "api", null);
            case 3:
              response = _context3.sent;
              if (response) {
                if (response.data.list_bank_accounts) {
                  _this5.listPaymentMethods = [].concat(_toConsumableArray(_this5.listPaymentMethods), _toConsumableArray(response.data.list_bank_accounts.map(function (x) {
                    return {
                      payment_method_id: x.payment_method_id,
                      user_id: x.user.id_user,
                      payment_type: paymentTypesWithCN.find(function (x) {
                        return x.name == "Sepa Direct Debit";
                      }).id,
                      payment_type_label: "Sepa Direct Debit",
                      label: "SEPA".concat(x.default ? " (default)" : "", " - ").concat(x.country, "***").concat(x.bank_name, "******").concat(x.last4, " - ").concat(getFullNameUser(x.user))
                    };
                  })));
                }
                if (response.data.list_us_bank_accounts) {
                  _this5.listPaymentMethods = [].concat(_toConsumableArray(_this5.listPaymentMethods), _toConsumableArray(response.data.list_us_bank_accounts.map(function (x) {
                    return {
                      payment_method_id: x.payment_method_id,
                      user_id: x.user.id_user,
                      payment_type: paymentTypesWithCN.find(function (x) {
                        return x.name == "ACH";
                      }).id,
                      payment_type_label: "ACH",
                      label: "ACH".concat(x.default ? " (default)" : "", " - ").concat(x.routing_number, "***").concat(x.bank_name, "******").concat(x.last4, " - ").concat(getFullNameUser(x.user))
                    };
                  })));
                }
                if (response.data.list_credit_cards) {
                  _this5.listPaymentMethods = [].concat(_toConsumableArray(_this5.listPaymentMethods), _toConsumableArray(response.data.list_credit_cards.map(function (x) {
                    return {
                      payment_method_id: x.payment_method_id,
                      user_id: x.user.id_user,
                      payment_type: paymentTypesWithCN.find(function (x) {
                        return x.name == "Credit Card";
                      }).id,
                      payment_type_label: "Credit Card",
                      label: "Credit Card".concat(x.default ? " (default)" : "", " - **** **** **** ").concat(x.last4, "  - ").concat(getFullNameUser(x.user), " - ").concat(x.exp_month, "/").concat(x.exp_year)
                    };
                  })));
                }
              }
              if (_this5.model.methodId) {
                _this5.modelPaymentMethod = _this5.listPaymentMethods.find(function (x) {
                  return x.payment_method_id === _this5.model.methodId;
                });
              } else {
                _this5.modelPaymentMethod = null;
              }
              _this5.isEditingPayment = true;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    updatePaymentMethod: function updatePaymentMethod() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.model.methodId = _this6.modelPaymentMethod.payment_method_id;
              _this6.model.type = _this6.modelPaymentMethod.payment_type;
              _this6.model.typeLabel = _this6.modelPaymentMethod.payment_type_label;
              _this6.model.userId = _this6.modelPaymentMethod.user_id;
              _this6.modelPaymentMethod = null;
              _this6.isEditingPayment = false;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    removePaymentMethod: function removePaymentMethod() {
      this.model.methodId = null;
      this.model.type = null;
      this.model.typeLabel = null;
      this.model.userId = null;
      this.model.scheduleDate = null;
    },
    cancelPaymentMethod: function cancelPaymentMethod() {
      this.isEditingPayment = false;
    },
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice
  }
};